/**
 * Branding Assets Configuration
 *
 * Contains all branding-related assets like logos, favicons, and OG images.
 * These URLs are referenced across the application.
 */

export const branding = {
  logo: {
    // Wordmark (horizontal) for desktop
    wordmarkLight: "https://media.thelightcall.com/logos/BK%20Academy%20500%20px%20white%20.png",
    wordmarkDark: "https://media.thelightcall.com/logos/BK%20Academy%20300%20px%20black.png",
    // Circular logo for mobile/compact (only white version exists on R2;
    // Header.jsx renders it with Tailwind `invert` for the beige header background)
    circularLight: "https://media.thelightcall.com/logos/BKA%20logo%201000%20px%20white.png",
    // circularDark: not uploaded yet — use circularLight + CSS invert instead
    // Footer logo (white)
    white: "https://media.thelightcall.com/logos/BK%20Academy%20500%20px%20white%20.png",
    alt: "Benjamin Kurtz Academy",
  },
  favicon: "/favicon.ico",
  ogImage: "https://media.thelightcall.com/images/og-image.jpg",
}
